"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWaitlistResponseDto = instanceOfWaitlistResponseDto;
exports.WaitlistResponseDtoFromJSON = WaitlistResponseDtoFromJSON;
exports.WaitlistResponseDtoFromJSONTyped = WaitlistResponseDtoFromJSONTyped;
exports.WaitlistResponseDtoToJSON = WaitlistResponseDtoToJSON;
exports.WaitlistResponseDtoToJSONTyped = WaitlistResponseDtoToJSONTyped;
var WaitlistJoinDataDto_1 = require("./WaitlistJoinDataDto");
/**
 * Check if a given object implements the WaitlistResponseDto interface.
 */
function instanceOfWaitlistResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function WaitlistResponseDtoFromJSON(json) {
    return WaitlistResponseDtoFromJSONTyped(json, false);
}
function WaitlistResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, WaitlistJoinDataDto_1.WaitlistJoinDataDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function WaitlistResponseDtoToJSON(json) {
    return WaitlistResponseDtoToJSONTyped(json, false);
}
function WaitlistResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, WaitlistJoinDataDto_1.WaitlistJoinDataDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
